<template>
  <section id="contact" class="contact">
    <h2>{{ $t("contact.title") }}</h2>
    <p>{{ $t("contact.description") }}</p>
    <div class="contact-links">
      <a href="mailto:raulnaharro0@gmail.com" class="contact-link">
        <font-awesome-icon :icon="['fas', 'envelope']" class="contact-icon" />
        <span>raulnaharro0@gmail.com</span>
      </a>
      <a
        href="https://linkedin.com/in/raulnaharro"
        target="_blank"
        class="contact-link"
      >
        <font-awesome-icon :icon="['fab', 'linkedin']" class="contact-icon" />
        <span>LinkedIn</span>
      </a>
      <a href="https://github.com/Zakees" target="_blank" class="contact-link">
        <font-awesome-icon :icon="['fab', 'github']" class="contact-icon" />
        <span>GitHub</span>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactComponent",
  data() {},
  methods: {},
};
</script>

<style scoped>
.contact {
  padding: 40px 20px;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  margin-bottom: 20px;
}

p {
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 30px;
}

.contact-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.contact-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #42b983;
  font-size: 1.2rem;
  transition: color 0.3s;
}

.contact-link:hover {
  color: #369f6e;
}

.contact-icon {
  font-size: 1.5rem;
  margin-right: 10px;
}

@media (max-width: 768px) {
  h2 {
    font-size: 2rem;
  }
  p {
    font-size: 1rem;
  }
  .contact-link {
    font-size: 1rem;
  }
}

/* Estilos para el modo oscuro */
.dark-mode .contact {
  color: #f0f0f0;
}

.dark-mode .contact h2 {
  color: #f0f0f0;
}

.dark-mode .contact p {
  color: #d0d0d0;
}

.dark-mode .contact-link {
  color: #42b983;
}

.dark-mode .contact-link:hover {
  color: #369f6e;
}
</style>
